/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfcraft_PlatformsInputs */

const en_pc_alt_t_pdfcraft_platforms = /** @type {(inputs: Pc_Alt_T_Pdfcraft_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, Linux, FreeBSD, web`)
};

const zh_pc_alt_t_pdfcraft_platforms = /** @type {(inputs: Pc_Alt_T_Pdfcraft_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS、Linux、FreeBSD、网页`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, Linux, FreeBSD, web" |
*
* @param {Pc_Alt_T_Pdfcraft_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfcraft_platforms = /** @type {((inputs?: Pc_Alt_T_Pdfcraft_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfcraft_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfcraft_platforms(inputs)
	return zh_pc_alt_t_pdfcraft_platforms(inputs)
});
export { pc_alt_t_pdfcraft_platforms as "pc.alt.t.pdfcraft.platforms" }